import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import getTimeDifference from "../../../../Common/TimeDifference";
import { formatNumberWithCommas, getPosttype } from "../../../../Common/AllDateTimeReleventFormate";
import { Tooltip } from "react-tooltip";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import { DeclineContractProposal } from "../../../../../redux/job/action";
import { useDispatch } from "react-redux";
import CustomeMilestone from "../../../../Common/CustomeLabel/CustomeMilestone";
import CustomeDurationLabel from "../../../../Common/CustomeLabel/CustomeDurationLabel";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import CustomeCategoryandSubcategory from "../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import { penaltytips } from "../../../../Common/Tooltips/tooltip";

export default function ManageAppliedProjectProposal({ posts, pd }) {
  const { urlstate, setManageAppliedprojectroute } = useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [loading, setLoading] = useState(false);
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();

  const hitthismethod = () => {
    setManageAppliedprojectroute("ProjectDetails");
    window.location.reload();
  };

  const acceptcontract = (id) => {
    const data = {
      type: "1",
      id: id,
      status: "4",
    };
    dispatch(DeclineContractProposal(data, setLoading, hitthismethod));
  };

  return (
    <div className="project-offer project-details ">
      {(pd?.status == 3 || pd?.status == 4 || pd?.status == 5) ? (
        <>
          <div className="post-details">
            {
              pd?.status == 4 ?
                <h2>Declined, your offer has been Declined</h2> :
                <h2>Congratulation 🎉, You received an offer</h2>
            }
            <div className="filter-detail">
              <div>
                <h5>
                  {posts.title} <span className="project">{getPosttype(posts.type)}</span>
                </h5>
                <div className="dollar-sec">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                      alt=""
                    />
                    {pd?.type == 2 ? "Prize" : "Budget"}: $
                    {formatNumberWithCommas(pd.price)}
                  </p>
                  {pd?.type == 3 ? (
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                        alt=""
                      />
                      Job type:
                      {pd?.work_location == 1
                        ? "Virtual"
                        : pd?.work_location == 2
                          ? "Physical"
                          : ""}
                    </p>
                  ) : (
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                        alt=""
                      />
                      Deadline:&nbsp;
                      <CustomeDurationLabel
                        duration={pd?.duration}
                        duration_type={pd?.duration_type}
                      />
                    </p>
                  )}
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                      alt=""
                    />
                    Posted:
                    {getTimeDifference(pd?.created_on)}
                  </p>
                </div>

                {/* <CustomeCategoryandSubcategory posts={posts} /> */}
                {/* <div className ="lang-sec">
                  <h6>Preferred language</h6>
                  <p>{posts?.language_title}</p>
                </div> */}
                <div className="lang-sec">
                  <h6>Description</h6>
                  <CustomReactQuillDescription value={posts?.description} />
                </div>
                {/* <CustomReactQuillDescription value={pd?.description} /> */}
                {/* {Array.isArray(pd?.skills) && pd?.skills?.length > 0 &&
                  <div className="lang-sec">
                    <h6>Competencies</h6>
                    <div className="photoshop">
                      {Array.isArray(pd?.skills) &&
                        pd?.skills.map((item1, index1) => (
                          <p key={index1}>{item1.title}</p>
                        ))}
                    </div>
                  </div>
                } */}
                {/* {Array.isArray(posts?.files) &&
                  posts?.files &&
                  posts?.files?.length > 0 && (
                    <div className ="lang-sec">
                      <h6>Attachments</h6>
                      <div className ="images">
                        {posts?.files &&
                          Array.isArray(posts?.files) &&
                          posts?.files.map((item, index) => {
                            return <DownloadwithDisplayProper item={item} />;
                          })}
                      </div>
                    </div>
                  )} */}
                <div className="proposal">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/proposal.svg`}
                      alt=""
                    />
                    {posts?.type == 2 ? "Entries" : "Proposal"}:
                    {posts.proposal_count}
                  </p>
                  {posts?.type == 3 ? (
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                        alt=""
                      />
                      Location: {posts.city_name}
                    </p>
                  ) : (
                    ""
                  )}
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                      alt=""
                    />
                    Verified Payment
                  </p>
                </div>
              </div>
            </div>
            <CustomeMilestone milestones={pd?.milestones} title={'Agreed milestone'} />
            {pd?.files?.length > 0 && Array.isArray(pd?.files) && (
              <div className="lang-sec">
                <h6>Attachments</h6>
                <div className="images">
                  {pd?.files.map((item, index) => {
                    return <DownloadwithDisplayProper item={item} />;
                  })}
                </div>
              </div>
            )}
            {
              pd?.status == 4 ?
                <div className="submit-btn">
                  <button
                    // onClick={() => DeclineContract()}
                    className="btn"
                    disabled
                  >
                    Declined
                  </button>

                </div> : pd?.status == 5 ?
                  <></> :
                  Array.isArray(pd?.milestones) && pd?.milestones[0]?.payment_status == 0 ? <></> :
                    <div className="submit-btn">
                      <button
                        className="btn"
                        onClick={() => {
                          acceptcontract(pd?.id);
                        }}
                      >
                        Decline offer
                      </button>
                      <button
                        className="btn post-btn"
                        onClick={() =>
                          navigate(`/${lan}/projectcontract/${pd.id}`, {
                            state: {
                              approvefrom: "user",
                              type_of_post: "project",
                              type: 1,
                            },
                          })
                        }
                      >
                        Accept offer
                      </button>
                    </div>
            }
          </div>
          <Tooltip
            id="my-tooltip-1"
            place="bottom"
            content={penaltytips}
          />
        </>) :
        <h5>No offer yet</h5>
      }
    </div >
  );
}
